import { NativeModules } from 'react-native';

type PayUPaymentGatewayType = {
  payu(params: {}): Promise<any>;
};

const { PayUPaymentGateway } = NativeModules;

export default PayUPaymentGateway as PayUPaymentGatewayType;
